import { render } from "./qnaWrite.vue?vue&type=template&id=6ed8986a&scoped=true"
import script from "./qnaWrite.vue?vue&type=script&lang=js"
export * from "./qnaWrite.vue?vue&type=script&lang=js"

import "@/assets//css/editer.css?vue&type=style&index=0&lang=css&external"
import "./qnaWrite.vue?vue&type=style&index=1&id=6ed8986a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed8986a"]])

export default __exports__